// extracted by mini-css-extract-plugin
export default {"form":"Gb9hi","okta":"w_GI3","entra":"uaI3N"};